export default __webpack_public_path__ + "ccf698badb509b1f35eb661fc8e5c1e8.svg";